// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.JoinCommunitySection_join-section__1QlwJ {
  background-color: transparent;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  padding: 56px 40px 80px;
}
@media (max-width: 767px) {
  .JoinCommunitySection_join-section__1QlwJ {
    padding: 28px 20px 56px;
  }
}

.JoinCommunitySection_container__w69R6 {
  max-width: 1240px;
  margin: 0 auto;
  width: 100%;
}

.JoinCommunitySection_card__llql3 {
  background-color: #F7F5F1;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
@media (min-width: 1081px) {
  .JoinCommunitySection_card__llql3 {
    flex-direction: row;
    min-height: 480px;
  }
}

.JoinCommunitySection_content__2JSw6 {
  padding: 48px 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1;
  background-color: #F7F5F1;
}
@media (min-width: 1081px) {
  .JoinCommunitySection_content__2JSw6 {
    padding: 52px 56px 54px;
    max-width: 55%;
  }
}

.JoinCommunitySection_eyebrow__dBvIj {
  margin: 0 0 16px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #82B194;
  text-transform: uppercase;
}
@media (max-width: 1080px) {
  .JoinCommunitySection_eyebrow__dBvIj {
    text-align: center;
  }
}

.JoinCommunitySection_title__et7yy {
  margin: 0 0 16px;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #13231D;
  max-width: 18ch;
}
@media (max-width: 1080px) {
  .JoinCommunitySection_title__et7yy {
    text-align: center;
    max-width: none;
  }
}
@media (min-width: 821px) {
  .JoinCommunitySection_title__et7yy {
    font-size: 42px;
  }
}

.JoinCommunitySection_description__nc\\+Fj {
  margin: 0 0 22px;
  font-size: 16px;
  line-height: 1.6;
  color: #5F726B;
  font-weight: 400;
}
@media (min-width: 768px) and (max-width: 1080px) {
  .JoinCommunitySection_description__nc\\+Fj {
    text-align: center;
  }
}
@media (min-width: 821px) {
  .JoinCommunitySection_description__nc\\+Fj {
    font-size: 17px;
  }
}

.JoinCommunitySection_btn-join__55ODd {
  background-color: #82B194;
  color: #FFFFFF;
  border: none;
  border-radius: 16px;
  padding: 0 22px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  align-self: flex-start;
  transition: background-color 0.3s ease;
  min-height: 48px;
}
@media (max-width: 1080px) {
  .JoinCommunitySection_btn-join__55ODd {
    align-self: center;
  }
}
.JoinCommunitySection_btn-join__55ODd:hover {
  background-color: rgb(114.2980295567, 167.2019704433, 134.5591133005);
}

.JoinCommunitySection_image-container__GZeFy {
  flex: 1 1;
  position: relative;
  min-height: 300px;
}
@media (min-width: 1081px) {
  .JoinCommunitySection_image-container__GZeFy {
    min-height: auto;
  }
}

.JoinCommunitySection_image__lW0UM {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  height: 444px;
  border-radius: 0px 30px 30px 0px;
  filter: saturate(0.88) contrast(1.04) brightness(1.03);
}
@media (max-width: 1080px) {
  .JoinCommunitySection_image__lW0UM {
    left: 50%;
    transform: translateX(-50%);
    border-radius: 30px;
    height: 280px;
    width: 600px;
  }
}

.JoinCommunitySection_image-overlay__j-zNQ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #F7F5F1 -20%, transparent 20%);
}
@media (min-width: 1081px) {
  .JoinCommunitySection_image-overlay__j-zNQ {
    background: linear-gradient(to right, #F7F5F1 -75%, transparent 50%);
    filter: saturate(0.88) contrast(1.04) brightness(1.03);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/JoinCommunitySection/JoinCommunitySection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACE,6BAAA;EACA,oFDEU;ECDV,uBAAA;AAiBF;AAfE;EALF;IAMI,uBAAA;EAkBF;AACF;;AAfA;EACE,iBAAA;EACA,cAAA;EACA,WAAA;AAkBF;;AAfA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAkBF;AAhBE;EAPF;IAQI,mBAAA;IACA,iBAAA;EAmBF;AACF;;AAhBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;AAmBF;AAjBE;EARF;IASI,uBAAA;IACA,cAAA;EAoBF;AACF;;AAjBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;AAoBF;AAlBE;EARF;IASI,kBAAA;EAqBF;AACF;;AAlBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AAqBF;AAnBE;EATF;IAUI,kBAAA;IACA,eAAA;EAsBF;AACF;AApBE;EAdF;IAeI,eAAA;EAuBF;AACF;;AApBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAuBF;AArBE;EAPF;IAQI,kBAAA;EAwBF;AACF;AAtBE;EAXF;IAYI,eAAA;EAyBF;AACF;;AAtBA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sCAAA;EACA,gBAAA;AAyBF;AAvBE;EAbF;IAcI,kBAAA;EA0BF;AACF;AAxBE;EACE,qEAAA;AA0BJ;;AAtBA;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;AAyBF;AAvBE;EALF;IAMI,gBAAA;EA0BF;AACF;;AAvBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;EACA,sDAAA;AA0BF;AAxBE;EATF;IAUI,SAAA;IACA,2BAAA;IACA,mBAAA;IACA,aAAA;IACA,YAAA;EA2BF;AACF;;AAxBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qEAAA;AA2BF;AAzBE;EARF;IASI,oEAAA;IACA,sDAAA;EA4BF;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.join-section {\n  background-color: transparent;\n  font-family: $font-main;\n  padding: 56px 40px 80px;\n\n  @media (max-width: 767px) {\n    padding: 28px 20px 56px;\n  }\n}\n\n.container {\n  max-width: 1240px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.card {\n  background-color: #F7F5F1;\n  border-radius: 24px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 1081px) {\n    flex-direction: row;\n    min-height: 480px;\n  }\n}\n\n.content {\n  padding: 48px 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  background-color: #F7F5F1;\n\n  @media (min-width: 1081px) {\n    padding: 52px 56px 54px;\n    max-width: 55%;\n  }\n}\n\n.eyebrow {\n  margin: 0 0 16px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #82B194;\n  text-transform: uppercase;\n\n  @media (max-width: 1080px) {\n    text-align: center;\n  }\n}\n\n.title {\n  margin: 0 0 16px;\n  font-size: 32px;\n  line-height: 1.15;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #13231D;\n  max-width: 18ch;\n\n  @media (max-width: 1080px) {\n    text-align: center;\n    max-width: none;\n  }\n\n  @media (min-width: 821px) {\n    font-size: 42px;\n  }\n}\n\n.description {\n  margin: 0 0 22px;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #5F726B;\n  font-weight: 400;\n\n  @media (min-width: 768px) and (max-width: 1080px) {\n    text-align: center;\n  }\n\n  @media (min-width: 821px) {\n    font-size: 17px;\n  }\n}\n\n.btn-join {\n  background-color: #82B194;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 16px;\n  padding: 0 22px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  align-self: flex-start;\n  transition: background-color 0.3s ease;\n  min-height: 48px;\n\n  @media (max-width: 1080px) {\n    align-self: center;\n  }\n\n  &:hover {\n    background-color: darken(#82B194, 5%);\n  }\n}\n\n.image-container {\n  flex: 1;\n  position: relative;\n  min-height: 300px;\n\n  @media (min-width: 1081px) {\n    min-height: auto;\n  }\n}\n\n.image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  object-fit: cover;\n  height: 444px;\n  border-radius: 0px 30px 30px 0px;\n  filter: saturate(.88) contrast(1.04) brightness(1.03);\n\n  @media (max-width: 1080px) {\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 30px;\n    height: 280px;\n    width: 600px;\n  }\n}\n\n.image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to bottom, #F7F5F1 -20%, transparent 20%);\n\n  @media (min-width: 1081px) {\n    background: linear-gradient(to right, #F7F5F1 -75%, transparent 50%);\n    filter: saturate(.88) contrast(1.04) brightness(1.03);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"join-section": `JoinCommunitySection_join-section__1QlwJ`,
	"container": `JoinCommunitySection_container__w69R6`,
	"card": `JoinCommunitySection_card__llql3`,
	"content": `JoinCommunitySection_content__2JSw6`,
	"eyebrow": `JoinCommunitySection_eyebrow__dBvIj`,
	"title": `JoinCommunitySection_title__et7yy`,
	"description": `JoinCommunitySection_description__nc+Fj`,
	"btn-join": `JoinCommunitySection_btn-join__55ODd`,
	"image-container": `JoinCommunitySection_image-container__GZeFy`,
	"image": `JoinCommunitySection_image__lW0UM`,
	"image-overlay": `JoinCommunitySection_image-overlay__j-zNQ`
};
export default ___CSS_LOADER_EXPORT___;
